// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RbSiI92CVXZ0NvQuZxXG{display:flex;justify-content:flex-end;gap:10px;padding-top:40px}`, "",{"version":3,"sources":["webpack://./src/components/UI/Smallville/ButtonsFooter/ButtonsFooter.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,wBAAA,CACA,QAAA,CACA,gBAAA","sourcesContent":[".buttonsFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-top: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonsFooter": `RbSiI92CVXZ0NvQuZxXG`
};
export default ___CSS_LOADER_EXPORT___;
